<template>
  <div class="blank"></div>
</template>

<script>
export default {
  name: "blank",
  data() {
    return {
      entityId: "",
      userId: "",
      fromApp: "",
      token: "",
      statusHeight: 0,
    };
  },
  mounted() {
    if (this.$route.query.entityId) {
      this.entityId = this.$route.query.entityId;
      this.userId = this.$route.query.userId;
      this.token = this.$route.query.token;
      this.$router.replace({
        path: "/detail",
        query: { entityId: this.entityId },
      });
    } else {
      this.$router.replace({
        path: "/detail",
        query: {
          reportId: this.$route.query.reportId,
          index: this.$route.query.index,
        },
      });
    }
  },

  methods: {},
};
</script>
<style scoped>
.blank {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
}
</style>
